import {
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  parse,
  isValid,
} from 'date-fns';
import {
  CalendarViewMode,
  PageQueryParams,
  START_DATE_PARAM,
  VIEW_PARAM,
} from './types';

function isCalendarViewMode(value: string | null): value is CalendarViewMode {
  return (
    value === 'day' || value === 'week' || value === 'month' || value === 'year'
  );
}

export function parsePageQueryParams(
  searchParams: URLSearchParams,
): PageQueryParams {
  const dateStr = searchParams.get(START_DATE_PARAM);
  let date: Date;
  if (dateStr) {
    const parsed = parse(dateStr, 'yyyy-MM-dd', new Date());
    date = isValid(parsed) ? parsed : new Date();
  } else {
    date = new Date();
  }

  const viewParam = searchParams.get(VIEW_PARAM);
  const mode: CalendarViewMode = isCalendarViewMode(viewParam)
    ? viewParam
    : 'week';

  return { date, mode };
}

export const getDateRangeForMode = (
  currentDay: Date,
  mode: CalendarViewMode,
) => {
  let rangeStart: Date;
  let rangeEnd: Date;

  switch (mode) {
    case 'day':
      rangeStart = startOfDay(currentDay);
      rangeEnd = endOfDay(currentDay);
      break;
    case 'week':
      rangeStart = startOfWeek(currentDay, { weekStartsOn: 1 });
      rangeEnd = endOfWeek(currentDay, { weekStartsOn: 1 });
      break;
    case 'month':
      rangeStart = startOfMonth(currentDay);
      rangeEnd = endOfMonth(currentDay);
      break;
    case 'year':
      rangeStart = startOfYear(currentDay);
      rangeEnd = endOfYear(currentDay);
      break;
    default:
      rangeStart = startOfWeek(currentDay, { weekStartsOn: 1 });
      rangeEnd = endOfWeek(currentDay, { weekStartsOn: 1 });
  }

  return {
    startDate: rangeStart.toISOString(),
    endDate: rangeEnd.toISOString(),
  };
};
